import { render, staticRenderFns } from "./TopasVisual.vue?vue&type=template&id=613b1604&scoped=true&"
import script from "./TopasVisual.vue?vue&type=script&lang=js&"
export * from "./TopasVisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b1604",
  null
  
)

export default component.exports